import PropTypes from "prop-types";
import {Grid , Box, Container} from "@mui/material";
import starIcon from "../assests/Images/starIcon.png";
import lineIcon from "../assests/Images/lineIcon2.png";
import joyLogo from "../assests/Images/joyLogo.png";

export default function AuthWrapper({ children }) {
  return (
    <Container>
     <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={1}
                  >
                    <img src={starIcon} alt="Star Icon" style={{ width: 60, height: "auto",marginTop:"40px" }} />
                    <img src={joyLogo} alt="Joy Logo" style={{ width: 120, height: "auto" }} />
                    <img src={lineIcon} alt="Line Icon" style={{ width: 60, height: "auto" ,marginTop:"40px"}} />
                  </Box>
    <Box
      sx={{
        minHeight: "40vh",
        maxWidth: { xs: 420, lg: 500 },
        margin: { xs: 2.5, md: 3 },
        "& > *": { flexGrow: 1, flexBasis: "50%" },
        justifySelf: "center",
      }}
    >
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{ minHeight: "50vh" }}
      >
        <Grid item xs={12}>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              minHeight: {
                xs: "calc(70vh - 64px)",
                sm: "calc(70vh - 64px)",
                md: "calc(70vh - 64px)",
              },
            }}
          >
            <Grid item sx={{border:"1px solid #cbcbcb",padding:"40px 30px",borderRadius:"10px",background:"white"}}>{children}</Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
    </Container>
  );
}

AuthWrapper.propTypes = { children: PropTypes.node };
